import { render, staticRenderFns } from "./my-project.vue?vue&type=template&id=5af4f52c&scoped=true&"
import script from "./my-project.vue?vue&type=script&lang=js&"
export * from "./my-project.vue?vue&type=script&lang=js&"
import style0 from "./my-project.vue?vue&type=style&index=0&id=5af4f52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4f52c",
  null
  
)

export default component.exports